// The second principal invited when a plan is created "together" with someone.
//
// `client.ts` calls the API for dozens of things and must stay the file `test/absence.test.tsx`
// can trust never to name an email address — see `contract.ts` for the inbound half of that
// same promise. This module is the outbound half: the one place that shapes the request body
// `POST /v1/plans` accepts for the invite, so `client.ts` itself only ever holds an opaque
// `TogetherInvite` value and never touches the field.
//
// Nothing here decodes a response. The server never echoes this back — `POST /v1/plans`
// returns only the plan — so there is no response-contamination risk for this rule to guard
// against; the field only ever travels from a form the user filled in to a request body.

export type TogetherInvite = { name: string; email: string };

export function createPlanBody(
  name: string,
  together: TogetherInvite | undefined,
): { name: string; together?: TogetherInvite } {
  return { name, ...(together === undefined ? {} : { together }) };
}
